module.exports = __webpack_public_path__ + "img/petty-cash.91d8de99.svg";